<button class="dark-mode-toggle" mat-icon-button (click)="darkMode.toggle()">
  <mat-icon>{{
    darkMode.isActivated ? "brightness_4" : "brightness_5"
  }}</mat-icon>
</button>
